import React, { useMemo } from 'react';
import styles from './Info.module.scss';
import InfoIcon from '../../assets/icons/Info.svg';
import { useInfoHints } from '../../components/context/InfoHintsContext';

export default function Info({ children, className = '', placement = 'top' }) {
  const { enabled } = useInfoHints();

  const rootClass = useMemo(() => {
    return [styles.info, className].filter(Boolean).join(' ');
  }, [className]);

  if (!enabled) return null;

  return (
    <span className={rootClass}>
      <button
        type='button'
        className={styles.info__btn}
        aria-label='Подсказка'
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <img src={InfoIcon} alt='' className={styles.info__icon} />
      </button>

      <span
        className={[
          styles.info__popover,
          placement === 'bottom'
            ? styles['info__popover--bottom']
            : styles['info__popover--top'],
        ].join(' ')}
        role='tooltip'
      >
        {children}
      </span>
    </span>
  );
}
